/**
 * Returns `true` when user uses mobile devices.
 */
export function isMobile() {
   if (window.innerWidth <= 768) {
      return true
   }

   return false
}

/**
 * List with callback which be invoked after window resize.
 */
const windowSizeCallbackList: Array<() => void> = []

/**
 *
 * @param callback - Callback which will be invoke after screen resize.
 */
export function addReportWindowSizeCallback(callback: () => void) {
   windowSizeCallbackList.push(callback)
}

/**
 * Function used to invoked all callbacks adter window resize.
 */
function reportWindowSize() {
   windowSizeCallbackList.forEach((callback) => {
      callback()
   })
}

window.onresize = reportWindowSize
